import { Card, Spinner, Table, Tooltip } from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DownArrow from "Assets/Icons/downArrow30.png";
import UpArrow from "Assets/Icons/upArrow30.png";
import { CommonTableInterface } from "utilFunctions/shared/CommonTable/CommonTableInterface";
import RenderColumns from "utilFunctions/shared/CommonTable/RenderColumns";
import { useState } from "react";
import InfoIcon from "Assets/Icons/InfoIcon";
import FeedbackViewModal from "Pages/Faculties/FeedbackViewModal";
// import React, { useEffect } from "react";
const SORT_ASC = "ASC";
const SORT_DESC = "DESC";
const CommonTable = ({
  isTableLoader,
  tableHeading,
  tableData,
  sortColumn,
  setSortColumn,
  sortOrder,
  setSortOrder,
  className,
  primaryMessage,
  secondaryMessage,
  noDataFoundClasName,
  sortingArray,
  extraInformation,
  onEdit,
  onDelete,
  onView,
}: CommonTableInterface) => {
  const { screen }: any = useWindowSize();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const [tooltipOpen1, setTooltipOpen1] = useState(false);
  const toggle1 = () => setTooltipOpen1(!tooltipOpen1);
  const [tooltipOpen2, setTooltipOpen2] = useState(false);
  const toggle2 = () => setTooltipOpen2(!tooltipOpen2);
  const [isLectureViewModal, setIsLectureViewModal] = useState<any>(false);
  const [selectedRowItem, setSelectedRowItem] = useState({});
  const handleSort = (column: any) => {
    sortOrder === SORT_ASC ? setSortOrder(SORT_DESC) : setSortOrder(SORT_ASC);
    setSortColumn(column);
  };
  const mapData = (aggregatedData: any, updatedDataForModal: any): [] => {
    const updatedFeedbackData = {
      behaviourInClassResponseAvg: aggregatedData.behaviourAvg,
      teachingPaceResponseAvg: aggregatedData.teachingPaceAvg,
      weightedNumberOfFeedback: aggregatedData.numberOfFeedbacks,
      overallRatingResponseAvg: aggregatedData.overallRatingAvg,
      doubtResolutionResponseAvg: aggregatedData.doubtResolutionAvg,
    };
    updatedDataForModal.push(updatedFeedbackData);
    return updatedDataForModal;
  };
  const handleOverAllratingmodal = (item: any) => {
    setSelectedRowItem((prevRowItem) => ({ ...prevRowItem, ...item }));
    setIsLectureViewModal(true);
  };
  return (
    <div
      className={
        ["xs", "sm", "md"].includes(screen)
          ? className
            ? className
            : "batchTableContainerMB"
          : className
          ? className
          : "batchTableContainer"
      }
    >
      <Card className="mb-0 table-border-custom">
        <div className="tableFixHead" style={{ overflowY: "auto" }}>
          {!isTableLoader && tableData && tableData.length == 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage={primaryMessage}
                secondaryMessage={secondaryMessage}
                noDataFoundClasName={noDataFoundClasName}
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <Table responsive className="table table-hover table-border-custom">
              <thead className="table-light-custom border-top table-border-custom">
                {tableHeading.map(
                  (column: { label: string; value: string }, index: number) => {
                    return (
                      <th
                        key={index}
                        onClick={() => {
                          if (sortingArray.includes(column.value)) {
                            handleSort(column.value);
                          }
                        }}
                      >
                        {column.label}
                        {column.value === "classAttended" ? (
                          <span className="tooltipSpan">
                            <InfoIcon id={"classAttended"}></InfoIcon>
                            <Tooltip
                              placement={"top"}
                              isOpen={tooltipOpen}
                              target={"classAttended"}
                              toggle={toggle}
                            >
                              {
                                "Student's overall class attendance for the current session"
                              }
                            </Tooltip>
                          </span>
                        ) : column.value === "riskSegment" ? (
                          <span className="tooltipSpan">
                            <InfoIcon id={"riskSegment"}></InfoIcon>
                            <Tooltip
                              placement={"top"}
                              isOpen={tooltipOpen1}
                              target={"riskSegment"}
                              toggle={toggle1}
                            >
                              {
                                "Likelihood of a student leaving the institute, calculated by an AI model based on performance, attendance, and other factors"
                              }
                            </Tooltip>
                          </span>
                        ) : column.value === "followUpCounts" ? (
                          <span className="tooltipSpan">
                            <InfoIcon id={"followUpCounts"}></InfoIcon>
                            <Tooltip
                              placement={"top"}
                              isOpen={tooltipOpen2}
                              target={"followUpCounts"}
                              toggle={toggle2}
                            >
                              {
                                "Total number of follow-up comments on the student's profile by all faculty members"
                              }
                            </Tooltip>
                          </span>
                        ) : null}
                        {sortingArray.includes(column.value) ? (
                          <span className="cursor-pointer">
                            {sortColumn == column.value &&
                            sortOrder === SORT_ASC ? (
                              <img width={16} height={12} src={UpArrow} />
                            ) : (
                              <img width={16} height={12} src={DownArrow} />
                            )}
                          </span>
                        ) : null}
                      </th>
                    );
                  }
                )}
              </thead>
              <tbody>
                {isTableLoader ? (
                  <tr>
                    <td colSpan={6}>
                      <div className="d-flex justify-content-center">
                        <Spinner color="info" />
                      </div>
                    </td>
                  </tr>
                ) : (
                  !isTableLoader &&
                  tableData &&
                  Array.isArray(tableData) &&
                  tableData.map((item: any, index: number) => {
                    return (
                      <tr key={index}>
                        {tableHeading.map(
                          (column: { label: string; value: string }) => (
                            <>
                              {" "}
                              <RenderColumns
                                item={item}
                                value={item[column.value]}
                                columnValue={column.value}
                                columnLabel={column.label}
                                index={index}
                                extraInformation={extraInformation}
                                onEdit={onEdit}
                                onDelete={onDelete}
                                onView={onView}
                                handleOverAllratingmodal={
                                  handleOverAllratingmodal
                                }
                              ></RenderColumns>
                            </>
                          )
                        )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          )}
        </div>
      </Card>
      {isLectureViewModal && selectedRowItem && (
        <FeedbackViewModal
          setYearMonthForFeedback={null}
          mode="myBatchLectureABC"
          selectedlecture={null}
          isLectureViewModal={isLectureViewModal}
          setIsLectureViewModal={setIsLectureViewModal}
          facultyFeedbackData={mapData(selectedRowItem, [])}
        ></FeedbackViewModal>
      )}
    </div>
  );
};
export default CommonTable;
